import type { ReactNode } from "react";

export interface TileProps {
  label: string;
  value: string;
  note?: string | undefined;
  tone?: "ok" | "warning" | "critical" | undefined;
  small?: boolean | undefined;
  /** Optional decoration beside the label. Purely presentational and always aria-hidden at the
   * call site - the label is what carries the meaning, so a tile without one reads identically. */
  icon?: ReactNode | undefined;
}

/** A single counter. The tone is carried by a class, never by an inline style: a style="..."
 * attribute is silently refused under `style-src 'self'`. */
export function Tile({ label, value, note, tone, small, icon }: TileProps) {
  const valueClass = [small ? "tile-value-sm" : "tile-value", tone ? `tone-${tone}` : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="tile">
      <div className="tile-label">
        {icon ? (
          <span className="tile-icon" aria-hidden="true">
            {icon}
          </span>
        ) : null}
        <span>{label}</span>
      </div>
      <div className={valueClass}>{value}</div>
      {note ? <div className="tile-note">{note}</div> : null}
    </div>
  );
}
